import http from '../../services/httpService';
import { ENV } from '../../configs/appConfig';
import {
  REMOVE_PROJECT,
  ADD_EMPLOYEE,
  ADD_PROJECTS,
  USER_PROFILE,
  FETCH_USER_PERMISSIONS,
  GET_SINGLE_EMPLOYEE,
  SET_RESOURCE_FILTER,
  RESET_RESOURCE_FILTERS,
} from './Types';
import axios from '../../services/httpService';
import { API_URL } from '../../constants/ApiUrls';
import { notificationMsg } from '../../utility/Notification';

const baseUrl = ENV.baseUrl;
const endPoint = `${baseUrl}`;

//Add currentEmployee
export const addEmployee = (data) => {
  return {
    type: ADD_EMPLOYEE,
    payload: data,
  };
};
//Add Projects
export const addProject = (projects) => {
  return {
    type: ADD_PROJECTS,
    payload: projects,
  };
};

// Remove Project
export const removeProject = (userId, projectId) => {
  return {
    type: REMOVE_PROJECT,
    payload: { userId: userId, projectId: projectId },
  };
};

export const getUsers = () => async (dispatch) => {
  const config = {
    method: 'get',
    url: `${baseUrl}/employee/getEmployees`,
  };
  try {
    const response = await axios(config);
    if (response && response.status === 200) {
      dispatch(showLoading(false));
      dispatch({
        type: 'GET_USERS',
        payload: response?.data,
        totalUsers: response?.data.employees,
        employeeProjects: response?.data.projects,
        roles: response?.data.roles,
        userPermissions: response?.data.user,
        projectManagers: response?.data.project_managers,
        devops: response?.data.devops,
      });
      localStorage.setItem('email', response?.data.user?.email);
      localStorage.setItem('pictureUrl', response?.data.user?.pictureUrl);
      // Fixed urgent crash with help of Mohsin, added question marks.
      // localStorage.setItem('name', response?.data.user.name)
      localStorage.setItem('name', response?.data.user?.name);
      localStorage.setItem('is_admin', response?.data.user?.is_admin);

      dispatch({
        type: USER_PROFILE,
        payload: response?.data?.user,
      });
    }
  } catch (error) {
    dispatch(showLoading(false));
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};
export const getEmployees = () => async (dispatch) => {
  const config = {
    method: 'get',
    url: `${baseUrl}/employee/getNewEmployees`,
  };
  try {
    const response = await axios(config);
    dispatch({
      type: 'SET_EMPLOYEES',
      employees: response?.data.employees,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

export const getResourceProjectDetails =
  ({ startDate, endDate }) =>
  async (dispatch) => {
    try {
      const response = await axios.get('employee/selectiveResourceProjectDetails', {
        params: {
          startDate,
          endDate,
        },
      });
      return response;
    } catch (e) {
      console.log('error: ', e);
    }
  };

export const getResourceFreePoolDetails =
  ({ startDate, endDate }) =>
  async (dispatch) => {
    try {
      const response = await axios.get('employee/resourcesFreePool', {
        params: {
          startDate,
          endDate,
        },
      });
      return response;
    } catch (e) {
      console.log('error: ', e);
    }
  };

export const editWorkShiftAction = (setEditWorkShift, editWorkShift) => async (dispatch) => {
  try {
    await axios.put(`/employee/${editWorkShift?.id}?flag=individual`, { work_shift: editWorkShift.value });
    notificationMsg('success', 'Work Shift updated successfully.');
    setEditWorkShift(null);
    dispatch(getEmployees());
  } catch (error) {
    notificationMsg('error', 'Something went wrong');
    setEditWorkShift(null);
  }
};

export const editAttendanceAction = (setEditAttendanceMode, editAttendanceMode) => async (dispatch) => {
  try {
    await axios.put(`/employee/${editAttendanceMode?.id}?flag=individual`, { attendanceMode: editAttendanceMode.value });
    notificationMsg('success', 'Attendance Mode updated successfully.');
    setEditAttendanceMode(null);
    dispatch(getEmployees());
  } catch (error) {
    notificationMsg('error', 'Something went wrong');
    setEditAttendanceMode(null);
  }
};

export const editDepartmentAction = (setEditDeparment, editDeparment) => async (dispatch) => {
  try {
    await axios.put(`/employee/${editDeparment?.id}?flag=individual`, { departmentId: editDeparment.value });
    notificationMsg('success', 'Department updated successfully.');
    setEditDeparment(null);
    dispatch(getEmployees());
  } catch (error) {
    notificationMsg('error', 'Something went wrong');
    setEditDeparment(null);
  }
};

export const editDivisionAction = (setEditDivision, editDivision) => async (dispatch) => {
  try {
    await axios.put(`/employee/${editDivision?.id}?flag=individual`, { divisionId: editDivision.value });
    notificationMsg('success', 'Division updated successfully.');
    setEditDivision(null);
    dispatch(getEmployees());
  } catch (error) {
    notificationMsg('error', 'Something went wrong');
    setEditDivision(null);
  }
};
export const editSubDepartmentAction = (setEditSubDepartment, editSubDepartment) => async (dispatch) => {
  try {
    if (!editSubDepartment?.deptId) {
      setEditSubDepartment(null);
      return notificationMsg('error', 'Please select department first in order to select sub department');
    }
    await axios.put(`/employee/${editSubDepartment?.id}?flag=individual`, {
      departmentId: editSubDepartment.deptId,
      subDepartmentId: editSubDepartment.value,
    });
    notificationMsg('success', 'Sub-Department updated successfully.');
    setEditSubDepartment(null);
    dispatch(getEmployees());
  } catch (error) {
    console.log('error =>>', error);
    notificationMsg('error', 'Something went wrong');
    setEditSubDepartment(null);
  }
};

export const editLocationAction = (setEditLocation, editLocation) => async (dispatch) => {
  try {
    await axios.put(`/employee/${editLocation?.id}?flag=individual`, {
      working_location: editLocation.value,
    });
    notificationMsg('success', 'Location updated successfully.');
    setEditLocation(null);
    dispatch(getEmployees());
  } catch (error) {
    console.log('error =>>', error);
    notificationMsg('error', 'Something went wrong');
    setEditLocation(null);
  }
};

export const getMyDeptOffBoard = () => async (dispatch) => {
  const config = {
    method: 'get',
    url: `${baseUrl}${API_URL.GET_EMPLOYEES_OFFBOARDING_BY_DEPARTMENT}`,
  };
  try {
    const response = await axios(config);
    dispatch({
      type: 'SET_MY_DEPT_OFF_BOARD_EMPLOYEES',
      offBoardEmployees: response?.data.data,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

export const getAllOffBoard = () => async (dispatch) => {
  const config = {
    method: 'get',
    url: `${baseUrl}${API_URL.GET_ALL_EMPLOYEES_OFFBOARDING}`,
  };
  try {
    const response = await axios(config);
    dispatch({
      type: 'SET_ALL_OFF_BOARD_EMPLOYEES',
      allOffBoardEmployees: response?.data.data,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

export const getArchivedEmployees = () => async (dispatch) => {
  const config = {
    method: 'get',
    url: `${baseUrl}/employee/getNewEmployees?records=DELETED`,
  };
  try {
    const response = await axios(config);
    dispatch({
      type: 'SET_ARCHIVED_USERS',
      archivedUsers: response?.data?.employees,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};
export const clearArchivedUsersState = () => {
  return {
    type: 'CLEAR_ARCHIVED_USERS_STATE',
  };
};
export const getRoles = () => async (dispatch) => {
  const config = {
    method: 'get',
    url: `${baseUrl}/role`,
  };
  try {
    const response = await axios(config);
    dispatch({
      type: 'SET_ROLES',
      payload: response.data.roles,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Get All Users
export const getAllUsers = () => {
  return (dispatch) => {
    http
      .get(endPoint)
      .then((response) => {
        dispatch({
          type: 'GET_ALL_USERS',
          payload: response.data.users,
        });
      })
      .catch((error) => {
        if (error.response) {
          const { data } = error.response;
          dispatch({
            type: 'ALL_USERS_FAIL',
            payload: data,
          });
        }
      });
  };
};

// Get Single User

export const getSingleEmployee = (id) => async (dispatch, getState) => {
  try {
    const response = await axios.post(`${baseUrl}/employee/getSingleEmployee`, {
      employee_id: id,
    });
    dispatch({
      type: GET_SINGLE_EMPLOYEE,
      payload: response.data.employee,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// ** Get User By Id **
export const getUserbyId = (userId) => {
  return (dispatch) => {
    http
      .get(`${endPoint}/${userId}`)
      .then((response) => {
        dispatch({
          type: 'GET_USER',
          payload: response.data.user,
        });
      })
      .catch((error) => {
        if (error.response) {
          const { errorMessage } = error.response.data;
          dispatch({
            type: 'USER_FAIL',
            payload: errorMessage,
          });
          notificationMsg('error', error?.response?.data?.error);
        }
      });
  };
};

// ** Get User By Id **
export const getUserbyLink = (link) => {
  return (dispatch) => {
    http
      .get(`${endPoint}/link/${link}`)
      .then((response) => {
        dispatch({
          type: 'GET_USER_BY_LINK',
          payload: response.data.user,
        });
      })
      .catch((error) => {
        if (error.response) {
          const { errorMessage } = error.response.data;
          dispatch({
            type: 'USER_FAIL_BY_LINK',
            payload: errorMessage,
          });
          notificationMsg('error', error?.response?.data?.error);
        }
      });
  };
};

// Add User
export const addUser = (body, users, allUsers) => {
  return (dispatch) => {
    http
      .post(`${endPoint}/addUser`, body)
      .then((response) => {
        if (response.data.success === true) {
          dispatch({
            type: 'ADD_USER',
            payload: response.data.user,
          });
          users.push(response.data.user);
          allUsers.push(response.data.user);
          const total = allUsers.length;
          dispatch({
            type: 'GET_USERS',
            payload: users,
            totalUsers: allUsers,
            totalPages: total,
          });
          notificationMsg('success', response.data.message);
        } else notificationMsg('error', response.data.error);
      })
      .catch((error) => {
        notificationMsg('error', error?.response?.data?.error);
      });
  };
};

// Eidt User
export const editUser = (userId, body) => {
  return (dispatch) => {
    http
      .put(`${endPoint}/updateUser/${userId}`, body)
      .then((response) => {
        if (response.data.success === true) {
          dispatch({
            type: 'Edit_USER',
            payload: response.data.updatedUser,
          });
          notificationMsg('success', response.data.message);
        } else notificationMsg('error', response.data.errorMessage);
      })
      .catch((error) => {
        notificationMsg('error', error?.response?.data?.error);
      });
  };
};

// Eidt User
export const bulkUpdateUsers = (body) => {
  return (dispatch) => {
    http
      .post(`${endPoint}/bulkUpdate`, body)
      .then((response) => {
        if (response.data.success === true) {
          dispatch({
            type: 'BULK_USERS',
            payload: response.data.isActive,
          });
          notificationMsg('success', response.data.message);
        } else {
          notificationMsg('error', response.data.errorMessage);
        }
      })
      .catch((error) => {
        notificationMsg('error', error?.response?.data?.error);
      });
  };
};

// Get Teams
export const getTeams = () => {
  return (dispatch) => {
    http
      .get(`${baseUrl}/teams`)
      .then((response) => {
        dispatch({
          type: 'GET_TEAMS',
          payload: response.data.teams,
        });
      })
      .catch((error) => {
        if (error.response) {
          const { data } = error.response;
          dispatch({
            type: 'TEAMS_FAIL',
            payload: data,
          });
        }
      });
  };
};

export const getSkills = () => (dispatch) => {
  http
    .get(`${baseUrl}/skill/getAllSkills`)
    .then((response) => {
      // Modify skills with status
      const modifiedSkillsWithStatus = response?.data?.skillsWithMonthlyAuditRequests?.map((item) => {
        return {
          ...item,
          name: item.Skill?.name,
        };
      });

      const allSkills = response?.data?.data;

      // Map all skills and add hasMonthlyAuditRequest flag
      const mergedSkills =
        allSkills?.length > 0
          ? allSkills.map((skill) => {
              const matchedSkill = modifiedSkillsWithStatus?.find((item) => item?.skillId === skill?.id);

              return {
                id: skill?.id,
                name: skill?.name,
                hasMonthlyAuditRequest: !!matchedSkill,
                ...matchedSkill,
              };
            })
          : [];

      dispatch({
        type: 'SET_SKILLS',
        payload: mergedSkills,
        permission: response.permission,
      });
    })
    .catch((error) => {
      if (error.response) {
        const { data } = error.response;
        dispatch({
          type: 'SKILLS_FAIL',
          payload: data,
        });
      }
    });
};

// Get Roles With Permissionss
export const getAllDivisions = () => async (dispatch) => {
  return new Promise(async (res, rej) => {
    try {
      const response = await axios.get(`${baseUrl}/division/get`);
      if (response && response.status === 200) {
        dispatch(showLoading(false));
        dispatch({
          type: 'SET_DIVISIONS',
          payload: response?.data?.divisions || [],
        });
      }
    } catch (error) {
      notificationMsg('error', error?.response?.data?.error);
    }
  });
};

// Get Roles With Permissionss
export const getRolesWithPermissions = () => async (dispatch) => {
  return new Promise(async (res, rej) => {
    try {
      const response = await axios.get(`${baseUrl}/rolePermission/get`);
      res(true);
      if (response && response.status === 200) {
        dispatch(showLoading(false));
        dispatch({
          type: 'GET_ROLES_PERMISSIONS',
          payload: response?.data?.roles || [],
        });
      }
    } catch (error) {
      notificationMsg('error', error?.response?.data?.error);
    }
  });
};
export const showLoading = (status) => {
  return {
    type: 'LOADING_ACTION',
    payload: status,
  };
};
export const addedSkills = (payload) => async (dispatch, getState) => {
  const state = getState();
  try {
    const response = await axios.post(`${baseUrl}/skill/create`, payload);

    // notificationMsg('error',"Something went wrong.")
    notificationMsg('success', 'Skill created successfully.');
    await dispatch({
      type: 'SET_SKILLS',
      payload: [response.data.skill, ...state.users.skillsList],
    });
  } catch (error) {
    notificationMsg('error', 'Duplicate skills are not allowed.');
  }
};

// Logout
// Clear permission tracking on logout
export const clearPermissionTracking = () => {
  permissionRequests.clear();
  // Note: fetchedUserIds and fetchedEmployeeIds are no longer used
  // We now use Redux state (permissionsByUserId) to track permissions
};

export const Logout = (dispatch) => {
  return (dispatch) => {
    // Clear permission tracking when logging out
    clearPermissionTracking();
    // Clear local storage
    localStorage.removeItem('tokenId');
    localStorage.removeItem('userEmail');
    localStorage.clear();
    // Add a delay or async call to ensure cleanup finishes
    setTimeout(() => {
      // Safely redirect after logout tasks complete
      window.location.href = '/login';
    }, 100); // Adjust the delay if necessary
  };
};

// Track ongoing requests to prevent duplicate calls
const permissionRequests = new Map();

// Helper function to get permissions for a specific userId from Redux state
export const getUserPermissionsFromState = (userId) => (dispatch, getState) => {
  const state = getState();
  const userPermissions = state?.userPermissions;
  
  if (userId && userPermissions?.permissionsByUserId?.[userId]) {
    return userPermissions.permissionsByUserId[userId];
  }
  
  // Fallback to current user if no userId provided or not found
  const currentUserId = userPermissions?.currentUserId;
  if (currentUserId && userPermissions?.permissionsByUserId?.[currentUserId]) {
    return userPermissions.permissionsByUserId[currentUserId];
  }
  
  return null;
};

// Unified Permission API - Always calls /permission/get without userId
// This API returns current user's employee data, permissions, and component data (iAm)
// All permissions are stored in Redux state by userId for reuse
export const getUserPermissoins = (userId = null) => async (dispatch, getState) => {
  const state = getState();
  const userPermissions = state?.userPermissions;
  
  // If userId is provided, check if we already have it in Redux state
  if (userId) {
    const cachedPermissions = userPermissions?.permissionsByUserId?.[userId];
    if (cachedPermissions && cachedPermissions.employee) {
      // Dispatch employee data for this userId
      dispatch({
        type: 'SET_EMPLOYEE_DATA',
        employee: cachedPermissions.employee,
      });
      // Dispatch component data if available
      if (cachedPermissions.iAm !== undefined) {
        dispatch({
          type: 'GET_MY_COMPONENT',
          payload: { iAm: cachedPermissions.iAm },
          myComponent: { iAm: cachedPermissions.iAm },
        });
      }
      return Promise.resolve({ data: cachedPermissions });
    }
  } else {
    // For current user, check if we already have complete data
    const currentUserId = userPermissions?.currentUserId;
    if (currentUserId && userPermissions?.permissionsByUserId?.[currentUserId]) {
      const currentUserPermissions = userPermissions.permissionsByUserId[currentUserId];
      if (currentUserPermissions.employee && Object.keys(currentUserPermissions.employee).length > 0) {
        return Promise.resolve({ data: currentUserPermissions });
      }
    }
  }
  
  // Check if a request is already in progress
  if (permissionRequests.has('current')) {
    return permissionRequests.get('current');
  }
  
  // Create a promise for this request
  const requestPromise = (async () => {
    try {
      
      // Always call permission API WITHOUT userId parameter
      const response = await axios.get(API_URL.GET_USER_PERMISSIONS);

      // Handle new response structure: {empPermission: {...}} or old structure: {employee: {...}}
      const employeeData = response?.data.empPermission !== undefined 
        ? response?.data.empPermission 
        : response?.data.employee;

      if (employeeData === null || employeeData === undefined) {
        // Still dispatch to Redux but with null employee
        dispatch({
          type: FETCH_USER_PERMISSIONS,
          payload: {
            ...response?.data,
            employee: null,
          },
        });
        return response;
      }
      
      // Store permissions in localStorage for current user
      if (employeeData.EmployeePermission == null) {
        localStorage.setItem('permissions', undefined);
      } else {
        localStorage.setItem('permissions', JSON.stringify(employeeData.EmployeePermission.permissions));
      }

      // Normalize the response structure for Redux - ensure 'employee' key exists
      const normalizedPayload = {
        ...response.data,
        employee: employeeData,
      };

      // Dispatch permission data - reducer will store by userId
      dispatch({
        type: FETCH_USER_PERMISSIONS,
        payload: normalizedPayload,
      });

      // Dispatch component data (iAm) if present in response
      if (response?.data?.iAm !== undefined) {
        dispatch({
          type: 'GET_MY_COMPONENT',
          payload: { iAm: response?.data?.iAm },
          myComponent: { iAm: response?.data?.iAm },
        });
      }

      // If a specific userId was requested and it matches the returned employee, dispatch employee data
      if (userId && employeeData && employeeData.id === userId) {
        dispatch({
          type: 'SET_EMPLOYEE_DATA',
          employee: employeeData,
        });
      } else if (!userId && employeeData?.id) {
        // For current user, also dispatch employee data
        dispatch({
          type: 'SET_EMPLOYEE_DATA',
          employee: employeeData,
        });
      }

      return response;
    } catch (error) {
      console.log('error in getUserPermissoins:', error);
      notificationMsg('error', error?.response?.data?.error || 'Failed to fetch permissions');
      throw error;
    } finally {
      // Remove the request from tracking after completion
      permissionRequests.delete('current');
    }
  })();
  
  // Store the promise in the map
  permissionRequests.set('current', requestPromise);
  
  return requestPromise;
};

// SelectedRow
export const rowSelection = (row, permissions) => {
  return {
    type: 'SELECTED_ROW',
    payload: { row, permissions },
  };
};
export const getSelectedRolePermissions = (permission) => {
  return {
    type: 'SELECTED_ROLE_PERMISSIONS',
    payload: permission,
  };
};
export const getProjectManagers = () => async (dispatch) => {
  try {
    const response = await axios.get(API_URL.GET_PROJECT_MANAGERS);
    const project_managers = response?.data?.project_managers || [];
    dispatch({
      type: 'SET_PROJECT_MANAGERS',
      payload: project_managers,
    });
  } catch (error) {
    console.error('Error fetching project managers:', error);
    dispatch({
      type: 'SET_PROJECT_MANAGERS',
      payload: [],
    });
  }
};
export const getDivisions = () => async (dispatch) => {
  try {
    const response = await axios.get(API_URL.GET_DIVISIONS);
    const divisions = response?.data || [];
    dispatch({
      type: 'SET_DIVISIONS',
      payload: divisions,
    });
  } catch (error) {
    console.error('Error fetching project managers:', error);
    dispatch({
      type: 'SET_DIVISIONS',
      payload: [],
    });
  }
};

// Get Employee Leaves
export const getEmployeeLeaves = () => async (dispatch) => {
  const config = {
    method: 'get',
    url: `${baseUrl}/employeeLeaves/getAll`,
  };
  try {
    const response = await axios(config);
    dispatch({
      type: 'SET_EMPLOYEES_LEAVES',
      employees: response?.data?.employeeLeaves,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Get Employee By Id - Uses Redux state first, then calls permission API if needed
// The permission API always returns current user's data, which is stored in Redux by userId
export const getEmployeeByIdHome = (id) => async (dispatch, getState) => {
  try {
    const state = getState();
    
    // First, check if we have this employee's data in Redux state
    const userPermissions = state?.userPermissions;
    const cachedPermissions = userPermissions?.permissionsByUserId?.[id];
    
    if (cachedPermissions && cachedPermissions.employee) {
      dispatch({ type: 'SET_STATE_NULL' });
      
      // Dispatch employee data
      dispatch({
        type: 'SET_EMPLOYEE_DATA',
        employee: cachedPermissions.employee,
      });
      
      // Dispatch component data (iAm) if available
      if (cachedPermissions.iAm !== undefined) {
        dispatch({
          type: 'GET_MY_COMPONENT',
          payload: { iAm: cachedPermissions.iAm },
          myComponent: { iAm: cachedPermissions.iAm },
        });
      }
      
      return;
    }
    
    // If not in Redux, check other state locations
    const employeeData = state?.users?.employeeInfo || state?.users?.selectedRow;
    if (employeeData && employeeData.id === id) {
      return;
    }
    
    dispatch({ type: 'SET_STATE_NULL' });
    
    // Call permission API (without userId - always gets current user's permissions)
    // Note: This will only get current user's data. If you need other users' data,
    // it should already be in Redux state from previous calls
    await dispatch(getUserPermissoins());
    
    // After fetching, check if the returned data matches the requested id
    const updatedState = getState();
    const updatedPermissions = updatedState?.userPermissions;
    const returnedEmployee = updatedPermissions?.employee;
    
    if (returnedEmployee && returnedEmployee.id === id) {
      // The returned data matches the requested id, dispatch it
      dispatch({
        type: 'SET_EMPLOYEE_DATA',
        employee: returnedEmployee,
      });
    } else {
      console.warn(`Requested employee id ${id} does not match returned employee id ${returnedEmployee?.id}. Make sure the employee data is available in Redux state.`);
    }
  } catch (error) {
    console.log('====> Error in getEmployeeByIdHome:', error);
    notificationMsg('error', error?.response?.data?.error || 'Failed to fetch employee data');
  }
};

// Get CEO
export const getCEO = () => async (dispatch) => {
  try {
    const response = await axios.get(`${baseUrl}/employee/getCEO`);
    dispatch({
      type: 'SET_CEO_DATA',
      employee: response?.data?.employee,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Apply Leave
export const employeeApplyLeave = (payload) => async (dispatch) => {
  try {
    const response = await axios.post(`${baseUrl}/employeeLeaves/create`, payload);
    dispatch({
      type: 'SET_CREATE_LEAVE',
      leave: response?.data?.employeeLeave,
    });
    notificationMsg('success', response?.data?.msg);
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.msg);
  }
};

// Update Employee Leave
export const updateEmployeeLeave = (payload) => async (dispatch) => {
  try {
    const response = await axios.put(`${baseUrl}/employeeLeaves/update`, payload);
    dispatch({
      type: 'SET_UPDATED_LEAVE',
      leave: response?.data?.updatedLeave,
    });
    notificationMsg('success', 'Leave request updated successfully.');
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Delete Employee Leave by HR
export const deleteEmployeeLeaveByHr = (payload) => async (dispatch) => {
  try {
    const response = await axios.put(`${API_URL.DELETE_LEAVE_BY_HR}${payload.id}`, payload.body);
    if (payload.tab === 'SYSTEM')
      dispatch({
        type: 'SET_DELETED_SYSTEM_LEAVE',
        leave: response.data.deletedLeave,
      });
    else
      dispatch({
        type: 'SET_DELETED_LEAVE',
        leave: response.data.deletedLeave,
      });
    notificationMsg('success', 'Leave request deleted successfully.');
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

export const checkAppliedLeave = (requestBody) => async (dispatch) => {
  try {
    const response = await axios.post(`${API_URL.CHECK_APPLIED_LEAVE}`, requestBody);
    if (response && response?.status === 200) {
      response?.data?.status && notificationMsg('error', `${response?.data?.message}`);
    }
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Delete Employee Leave
export const deleteEmployeeLeave = (payload) => async (dispatch) => {
  try {
    await axios.post(`${API_URL.DELETE_LEAVE}${payload.id}`, payload.body);
    notificationMsg('success', 'Leave request deleted successfully.');
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Get Resources Leaves of Manager
export const getResourcesLeaves = () => async (dispatch) => {
  const config = {
    method: 'get',
    url: `${baseUrl}/employeeLeaves/getResourcesLeaves`,
  };
  try {
    const response = await axios(config);
    dispatch({
      type: 'SET_RESOURCES_LEAVES_OF_MANAGER',
      leaves: response?.data?.resourcesLeavesWithStatus,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Update Leave Status
export const updateLeaveStatus = (payload) => async (dispatch) => {
  try {
    const response = await axios.put(`${baseUrl}/employeeLeaves/updateLeaveStatus`, payload);
    notificationMsg('success', response?.data?.msg);
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.msg);
  }
};

// Get All Employee Leaves for HR
export const getEmployeeLeavesHR = () => async (dispatch) => {
  try {
    const response = await axios.get(API_URL.GET_ALL_LEAVES_HR);
    dispatch({
      type: 'SET_EMPLOYEE_LEAVES_OF_HR',
      payload: response?.data?.employeeLeaves,
      countExport: response?.data?.employeeLeaveCount,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Get All Deleted Leaves for HR
export const getAllDeletedLeavesForHr = () => async (dispatch) => {
  try {
    const response = await axios.get(API_URL.GET_ALL_DELETED_LEAVES_HR);
    dispatch({
      type: 'SET_DELETED_LEAVES',
      payload: response?.data?.employeeLeaves,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Get All System Deleted Leaves for HR
export const getAllSystemDeletedLeavesForHr = () => async (dispatch) => {
  try {
    const response = await axios.get(API_URL.GET_ALL_SYSTEM_DELETED_LEAVES_HR);
    dispatch({
      type: 'SET_SYSTEM_DELETED_LEAVES',
      payload: response?.data?.employeeLeaves,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Update Leave Status by HR
export const updateLeaveStatusByHr = (payload) => async (dispatch) => {
  try {
    const response = await axios.put(API_URL.UPDATE_LEAVE_STATUS_HR, payload);
    notificationMsg('success', response?.data?.msg);
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Send Notification to PMs
export const sendLeaveNotificationToPMs = (payload) => async (dispatch) => {
  try {
    await axios.post(API_URL.SEND_NOTIFICATION_TO_PMs, payload);
    notificationMsg('success', 'Notification sent to PMs from which leave is pending');
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// System generated leaves for HR
export const getSystemGeneratedLeavesForHr = () => async (dispatch) => {
  try {
    const response = await axios.get(API_URL.SYSTEM_LEAVES_HR);
    dispatch({
      type: 'SET_SYSTEM_LEAVES_OF_HR',
      payload: response?.data?.employeeLeaves,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// System generated leaves for PM
export const getSystemGeneratedLeavesForPm = () => async (dispatch) => {
  try {
    const response = await axios.get(API_URL.SYSTEM_LEAVES_PM);
    dispatch({
      type: 'SET_SYSTEM_LEAVES_OF_PM',
      payload: response?.data?.resourcesLeavesWithStatus,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Get All Resources
export const getAllResources = () => async (dispatch) => {
  try {
    const response = await axios.get(API_URL.GET_ALL_RESOURCES);
    dispatch({
      type: 'SET_ALL_RESOURCES',
      payload: response?.data,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Create Gift Leave
export const createGiftLeave = (payload) => async (dispatch) => {
  try {
    const response = await axios.post(API_URL.CREATE_GIFT_LEAVE, payload);
    notificationMsg('success', response?.data?.msg);
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Get GIFT Leaves
export const getGiftLeaves = () => async (dispatch) => {
  try {
    const response = await axios.get(API_URL.GET_GIFT_LEAVES);
    dispatch({
      type: 'SET_GIFT_LEAVES',
      payload: response?.data,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Get All Deleted Gift Leaves for HR
export const getAllDeletedGiftLeavesForHr = () => async (dispatch) => {
  try {
    const response = await axios.get(API_URL.GET_ALL_DELETED_GIFT_LEAVES_HR);
    dispatch({
      type: 'SET_DELETED_GIFT_LEAVES',
      payload: response?.data,
    });
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Delete Gift Leave
export const deleteGiftLeave = (payload) => async (dispatch) => {
  try {
    const response = await axios.delete(API_URL.DELETE_GIFT_LEAVE, { data: payload });
    notificationMsg('success', response?.data?.message);
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Update Leave Quota
export const updateLeaveQuota = (id, payload, setIsProjectDelete) => async (dispatch) => {
  try {
    const response = await axios.put(`/employeeLeaves/${id}`, payload);
    response && response?.data && setIsProjectDelete?.(true);
    response && response?.data && notificationMsg('success', response?.data?.msg);
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Update Leave Type
export const updateLeaveType = (payload) => async (dispatch) => {
  try {
    await axios.post(`/employeeLeaves/updateLeaveTypeByResource`, payload);
    notificationMsg('success', 'Leave updated successfully.');
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.message);
  }
};
// ------------ Resource Filter ----------------
export const setResource = (data) => (dispatch) => {
  dispatch({
    type: SET_RESOURCE_FILTER,
    payload: data,
  });
};

export const resetResourceFilters = () => (dispatch) => {
  dispatch({
    type: RESET_RESOURCE_FILTERS,
  });
};

export const deleteEmployeeForcefully = (employee_id) => async (dispatch) => {
  try {
    await axios.post(`${API_URL.DELETE_EMPLOYEE_FORCEFULLY}`, { employeeId: employee_id });
    notificationMsg('success', 'Resource deleted successfully.');
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

export const deleteEmployeeOffBoardingRequest = (boardingRequestId) => async (dispatch) => {
  try {
    await axios.delete(`${API_URL.DESTROY_EMPLOYEE_OFFBOARD_REQ}`, { data: { boardingRequestId } });
    notificationMsg('success', 'Offboarding request deleted successfully.');
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};

// Update Employee Saturdays
export const updateEmployeeSaturday = (payload, setState) => async (dispatch) => {
  try {
    const response = await axios.put(`${baseUrl}${API_URL.UPDATE_EMPLOYEE_SATURDAYS}`, payload);
    if (response?.status === 200) {
      dispatch(getAllResources());
      notificationMsg('success', response?.data?.msg);
      setState(false);
    }
  } catch (error) {
    console.log('====>', error);
    notificationMsg('error', error?.response?.data?.error);
  }
};
